import { render, staticRenderFns } from "./DashboardWidgetFrame.vue?vue&type=template&id=0c9ed0c2&scoped=true"
import script from "./DashboardWidgetFrame.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetFrame.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetFrame.vue?vue&type=style&index=0&id=0c9ed0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ed0c2",
  null
  
)

export default component.exports